const EmbeddedYouTubePlaylist = (props) => {
    return (
        <div className="youtube-playlist-container">
            <div className="youtube-playlist-viewport">
                <iframe
                    src={"https://www.youtube.com/embed/videoseries?list=" + props.playlistId}
                    title="YouTube video player"
                    frameborder="0"
                    tabIndex="-1"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                    tabIndex="0"
                ></iframe>
            </div>
            <a className="youtube-playlist-text" target="_blank" href={"https://www.youtube.com/playlist?list=" + props.playlistId} aria-label={props.descriptionText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                {props.descriptionText}
            </a>
        </div>
    );
};

export default EmbeddedYouTubePlaylist;